/**
 * The fictional demo companies (ids demo-1..demo-6). Kept in a tiny module so
 * the client-safe anonymizer (src/lib/demo-mode.ts) can whitelist their names
 * without pulling the full demo-data generator bundle into the client.
 */
export const DEMO_COMPANIES = [
  { name: "Apex Digital Co.", website: "https://apexdigital.com", industry: "Technology" },
  { name: "Greenleaf Landscaping", website: "https://greenleaflandscape.com", industry: "Home Services" },
  { name: "Summit Healthcare", website: "https://summithealth.com", industry: "Healthcare" },
  { name: "Coastal Real Estate Group", website: "https://coastalrealestate.com", industry: "Real Estate" },
  { name: "Ironforge Manufacturing", website: "https://ironforgemfg.com", industry: "Manufacturing" },
  { name: "Bluebird Café & Bakery", website: "https://bluebirdcafe.com", industry: "Food & Beverage" },
];
